import React from 'react'
import { Route, Routes } from 'react-router-dom'

import ApiKeyActivation from './ApiKeyActivation'
import EmailVerification from './EmailVerification'
import PasswordReset from './PasswordReset'

const PublicRoutes = () => (
  <Routes>
    <Route path='/trade/api/key/activate/:id' element={<ApiKeyActivation />} />
    <Route path='/trade/users/verification-code/:id/:code' element={<EmailVerification />} />
    <Route path='/trade/password/reset/:code' element={<PasswordReset />} />
  </Routes>
)

export default PublicRoutes
